import References from "@/components/References";
import SEOHead from "@/components/SEOHead";
import { REFERENCES } from "@/data/content";

export default function ReferencesPage() {
  return (
    <>
      <SEOHead
        title="Referenzen – EasyRohbau | Realisierte Bauprojekte"
        description="Eine Auswahl unserer realisierten Rohbau-Projekte in Köln, Bonn, Düsseldorf und der Region NRW. Ein- und Mehrfamilienhäuser, Gewerbebau und Sanierung."
      />
      <section className="pt-32 pb-8 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">Referenzen</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0C2749] tracking-tight max-w-3xl" style={{ fontFamily: "Outfit" }}>
            Projekte, die für sich sprechen.
          </h1>
          <p className="text-slate-600 max-w-2xl mt-6">
            Eine Auswahl unserer Rohbau-Realisierungen aus den letzten Jahren. Von der Stadtvilla bis zum Gewerbecampus.
          </p>
        </div>
      </section>
      <References limit={REFERENCES.length} />
    </>
  );
}
